export function loadAiImprovePlugin() {
  const translations = {
    en: {
      item1: 'Rephrase',
      item2: 'Shorten',
      item3: 'Summarize',
    },
    fr: {
      item1: 'Reformuler',
      item2: 'Raccourcir',
      item3: 'Résumer',
    },
    de: {
      item1: 'Umformulieren',
      item2: 'Kürzen',
      item3: 'Zusammenfassen',
    },
    es: {
      item1: 'Reformular',
      item2: 'Reducir',
      item3: 'Resumir',
    },
    it: {
      item1: 'Riformulare',
      item2: 'Accorciare',
      item3: 'Riassumere',
    },
    pl: {
      item1: 'Przekształć',
      item2: 'Skróć',
      item3: 'Podsumuj',
    },
    ro: {
      item1: 'Reformulează',
      item2: 'Prescurtează',
      item3: 'Rezumă',
    },
    cz: {
      item1: 'Přeformulovat',
      item2: 'Zkrátit',
      item3: 'Shrnout',
    },
    nl: {
      item1: 'Herformuleren',
      item2: 'Verkorten',
      item3: 'Samenvatten',
    },
    tr: {
      item1: 'Yeniden ifade et',
      item2: 'Kısalt',
      item3: 'Özetle',
    },
    uk: {
      item1: 'Перефразувати',
      item2: 'Скоротити',
      item3: 'Підсумувати',
    },
  };

  FroalaEditor.PLUGINS.aiImprove = function (editor) {
    return {
      dropdownCallback: function (cmd, val) {
        const options = FroalaEditor.COMMANDS['aiImprove'].options();
        const actionLabel = options[val];
        editor.events.trigger('aiImprove.itemClicked', [actionLabel]);
      }
    };
  };

  FroalaEditor.DefineIcon('improveIcon', {
    SRC: '/assets/images/froala-plugins/improve.icon.png',
    ALT: 'Improve',
    template: 'image'
  });

  FroalaEditor.RegisterCommand('aiImprove', {
    title: 'Improve',
    type: 'dropdown',
    icon: 'improveIcon',
    options: function () {
      const editorInstance = FroalaEditor.INSTANCES[0];
      const lang = editorInstance?.opts?.language || 'en';

      return translations[lang] || translations['en'];
    },

    callback: function (cmd, val) {
      this.aiImprove.dropdownCallback(cmd, val);
    },

    refresh: function ($btn) {
      const selectedText = this.selection?.get()?.toString() || '';
      if (!selectedText.trim()) {
        $btn.addClass('fr-disabled');
      } else {
        $btn.removeClass('fr-disabled');
      }
    },
  });
}
